import { ColorType } from '../types'

type InputVariantType = [
  ColorType, // 0 - background
  ColorType, // 1 - background (disabled state)
  ColorType, // 2 - background (active state)
  ColorType, // 3 - border
  ColorType, // 4 - border (active state)
  ColorType, // 5 - label
  ColorType, // 6 - text (content)
  ColorType, // 7 - text (disabled state)
  ColorType, // 8 - text (active state)
  ColorType, // 9 - placeholder
  ColorType, // 10 - placeholder (active state)
  ColorType, // 11 - checkbox
  ColorType, // 12 - checkbox (checked state)
  ColorType, // 13 - checkbox border-color
  ColorType // 14 - checkbox border-color (checked state)
]

const variant: { [name: string]: InputVariantType } = {
  cashflow: [
    'white',
    'grey000',
    'white',
    'grey000',
    'dark000',
    'dark200',
    'dark900',
    'dark200',
    'dark900',
    'dark200',
    'dark000',
    'whiteAlpha05',
    'white',
    'transparent',
    'transparent'
  ],
  chatMessage: [
    'whiteAlpha05',
    'whiteAlpha05',
    'whiteAlpha05',
    'transparent',
    'transparent',
    'whiteAlpha50',
    'dark900',
    'dark900',
    'dark900',
    'dark200',
    'dark000',
    'whiteAlpha05',
    'white',
    'transparent',
    'transparent'
  ],
  createApiKey: [
    'grey000',
    'grey000',
    'white',
    'transparent',
    'blue600',
    'dark900',
    'dark900',
    'dark200',
    'dark900',
    'dark200',
    'dark000',
    'whiteAlpha05',
    'blue600',
    'dark000',
    'blue600'
  ],
  instrumentSearch: [
    'overlayWhite100',
    'whiteAlpha05',
    'whiteAlpha05',
    'transparent',
    'transparent',
    'whiteAlpha50',
    'white',
    'white',
    'white',
    'grey000',
    'grey000',
    'whiteAlpha05',
    'white',
    'transparent',
    'transparent'
  ],
  normal: [
    'white',
    'grey000',
    'white',
    'dark000',
    'blue600',
    'dark200',
    'dark900',
    'dark200',
    'dark900',
    'dark200',
    'dark000',
    'whiteAlpha05',
    'white',
    'transparent',
    'transparent'
  ],
  qrCodeModal: [
    'dark700',
    'dark700',
    'dark700',
    'transparent',
    'transparent',
    'transparent',
    'dark200',
    'dark200',
    'dark200',
    'transparent',
    'transparent',
    'transparent',
    'transparent',
    'transparent',
    'transparent'
  ],
  settings: [
    'whiteAlpha10',
    'overlayWhite100',
    'whiteAlpha10',
    'transparent',
    'whiteAlpha25',
    'dark200',
    'white',
    'whiteAlpha25',
    'white',
    'whiteAlpha50',
    'whiteAlpha50',
    'whiteAlpha10',
    'blue600',
    'transparent',
    'transparent'
  ],
  sidebar: [
    'transparent',
    'transparent',
    'transparent',
    'transparent',
    'transparent',
    'dark200',
    'dark300',
    'whiteAlpha25',
    'dark300',
    'whiteAlpha50',
    'whiteAlpha50',
    'whiteAlpha10',
    'blue600',
    'transparent',
    'transparent'
  ],
  tradeTicket: [
    'white',
    'whiteAlpha05',
    'white',
    'transparent',
    'transparent',
    'white',
    'dark900',
    'whiteAlpha50',
    'dark900',
    'overlayDark400',
    'dark300',
    'white',
    'overlayDark400',
    'transparent',
    'transparent'
  ]
}

export default variant
